import React, { useEffect, useState, useRef } from "react";
import Select from "react-select";

const documentTypeOptions = [
  { value: "aadhar_card", label: "Aadhar Card" },
  { value: "pan_card", label: "PAN Card" },
  { value: "leaving_certificate", label: "Leaving Certificate" },
  { value: "appointment_letter", label: "Appointment Letter" },
];

const DocumentUploader = ({ documents: propDocuments = [], onChange }) => {
  const [selectedType, setSelectedType] = useState(null);
  const [file, setFile] = useState(null);
  const [documents, setDocuments] = useState([]);
  const fileInputRef = useRef(null);

  // Sync internal state with prop
  useEffect(() => {
    setDocuments(propDocuments);
  }, [propDocuments]);

  const convertToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleConfirm = async () => {
    if (!selectedType || !file) {
      alert("Please select a document type and choose a file.");
      return;
    }

    const isAlreadyUploaded = documents.find(
      (doc) => doc.type === selectedType.value
    );
    if (isAlreadyUploaded) {
      alert("This document type is already uploaded.");
      return;
    }

    try {
      const base64 = await convertToBase64(file);

      const newDoc = {
        type: selectedType.value,
        label: selectedType.label,
        fileName: file.name,
        base64,
      };

      const updatedDocs = [...documents, newDoc];
      setDocuments(updatedDocs);
      onChange?.(updatedDocs); // Notify parent if handler provided

      // Reset UI
      setSelectedType(null);
      setFile(null);
      fileInputRef.current.value = "";
    } catch (err) {
      console.error("Error converting file:", err);
    }
  };

  const handleDelete = (type) => {
    const updatedDocs = documents.filter((doc) => doc.type !== type);
    setDocuments(updatedDocs);
    onChange?.(updatedDocs);
  };

  const handleDownload = (doc) => {
    window.open(doc.base64, "_blank");
  };

  return (
    <div>
      <div style={{ marginBottom: "20px" }}>
        <Select
          options={documentTypeOptions.filter(
            (opt) => !documents.some((doc) => doc.type === opt.value)
          )}
          value={selectedType}
          onChange={setSelectedType}
          placeholder="Select document type"
          isClearable
        />

        {selectedType && (
          <div style={{ marginTop: "15px" }}>
            <input type="file" onChange={handleFileChange} ref={fileInputRef} />
            <button
              type="button"
              style={{
                marginLeft: "10px",
                backgroundColor: "#1976d2",
                color: "#fff",
                border: "none",
                padding: "6px 14px",
                borderRadius: "5px",
                cursor: "pointer",
              }}
              onClick={handleConfirm}
            >
              Confirm
            </button>
          </div>
        )}
      </div>

      {documents.length > 0 && (
        <>
          <div className="card-title">Uploded Document</div>
          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              marginTop: "10px",
            }}
          >
            <thead>
              <tr style={{ backgroundColor: "#f0f0f0" }}>
                <th style={{ padding: "10px", border: "1px solid #ccc" }}>
                  Type
                </th>
                <th style={{ padding: "10px", border: "1px solid #ccc" }}>
                  File Name
                </th>
                <th style={{ padding: "10px", border: "1px solid #ccc" }}>
                  Actions
                </th>
              </tr>
            </thead>
            <tbody>
              {documents.map((doc, index) => (
                <tr key={index}>
                  <td style={{ padding: "10px", border: "1px solid #ccc" }}>
                    {doc.label}
                  </td>
                  <td style={{ padding: "10px", border: "1px solid #ccc" }}>
                    {doc.fileName}
                  </td>
                  <td style={{ padding: "10px", border: "1px solid #ccc" }}>
                    <button
                      onClick={() => handleDownload(doc)}
                      style={{
                        marginRight: "10px",
                        padding: "5px 10px",
                        backgroundColor: "#4caf50",
                        color: "white",
                        border: "none",
                        borderRadius: "4px",
                        cursor: "pointer",
                      }}
                    >
                      Download
                    </button>
                    <button
                      onClick={() => handleDelete(doc.type)}
                      style={{
                        padding: "5px 10px",
                        backgroundColor: "#f44336",
                        color: "white",
                        border: "none",
                        borderRadius: "4px",
                        cursor: "pointer",
                      }}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </>
      )}
    </div>
  );
};

export default DocumentUploader;
